module.exports = __webpack_public_path__ + "img/cycle.3120d58e.png";